export const CardCustomizationActionTypes = {
  CUSTOMIZATION_CLEANUP: 'zola/card/card_customization/CUSTOMIZATION_CLEANUP',
  SET_CUSTOMIZATION_ERROR_LIST: 'zola/card/card_customization/SET_CUSTOMIZATION_ERROR_LIST',
  CLEAR_CUSTOMIZATION_ERROR_LIST: 'zola/card/card_customization/CLEAR_CUSTOMIZATION_ERROR_LIST',
};

export default CardCustomizationActionTypes;
